import React, { useEffect, useRef } from "react";

// Keep srcObject attachment independent from parent renders and dragging.
export function StreamVideo({ stream, contain = false, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const video = ref.current;
    video.srcObject = stream || null;
    if (stream) video.play()?.catch(() => {});
    return () => {
      video.srcObject = null;
    };
  }, [stream]);
  return (
    <video
      ref={ref}
      autoPlay
      playsInline
      muted
      draggable={false}
      className={`ant-call-video ${className}`}
      style={{ objectFit: contain ? "contain" : "cover" }}
    />
  );
}

// One audio element per remote person, regardless of which videos are visible.
// Turning a camera off or hiding chat must not also remove that person's audio.
export function RemoteAudio({ stream, userId, elements, onBlocked }) {
  const ref = useRef(null);
  useEffect(() => {
    const audio = ref.current;
    elements.current.set(userId, audio);
    audio.srcObject = stream || null;
    if (stream) audio.play()?.catch(() => onBlocked());
    return () => {
      elements.current.delete(userId);
      audio.srcObject = null;
    };
  }, [stream, userId, elements, onBlocked]);
  return <audio ref={ref} autoPlay playsInline />;
}
